import { useEffect, useRef } from 'react';

/**
 * https://www.joshwcomeau.com/snippets/react-hooks/use-timeout/
 *
 * This hook is a "react-friendly" wrapper around setTimeout. You can use it just like you'd use window.setTimeout, and it'll work as you expect.
 *
 * useTimeout will be called whenever the component renders, instead of only once when the component mounts. If our parent component re-renders 10 times, we'll call it 10 times.
 *
 * You can cancel the timeout by changing the delay property to null
 */
export const useTimeout = (callback, delay) => {
  const timeoutRef = useRef(null);
  const savedCallback = useRef(callback);
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(() => {
    const tick = () => savedCallback.current();
    if (typeof delay === 'number') {
      timeoutRef.current = window.setTimeout(tick, delay);
      return () => {
        if (timeoutRef.current) {
          window.clearTimeout(timeoutRef.current);
        }
      };
    }
    return () => {};
  }, [delay]);
  return timeoutRef;
};